import React, { useMemo, useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { connect } from "react-redux";

import { useLoading } from "app/custom-hooks/loadingHook";
import { EngagementVerticals } from "app/pages/segments/mmx/EngagementVerticals";
import type { ISegmentsMMXGraphData } from "app/pages/segments/mmx/mmxGraphData";
import { GroupMMXContainer } from "app/pages/segments/mmx/styledComponents";
import { getTableSelectedItems } from "app/reducers/_reducers/tableSelection.reducer";
import SegmentsApiService from "app/services/segments/segmentsApiService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { SegmentsGroupMMXGraph } from "./SegmentsGroupMMXGraph";
import SegmentsGroupMMXTable from "./SegmentsGroupMMXTable";

const SegmentsGroupMarketingChannelsContainer = (props) => {
    const { selectedRows, segments, organizationSegments, groups } = props;
    const { params } = useCurrentStateAndParams();
    const apiParams = proNavigator.getApiParams(params);
    const groupData = groups.find((group) => group.id === params.id);
    const [, setMissingFireboltSegment] = useState(0);
    const [selectedDisplayTypeIndex, setSelectedDisplayTypeIndex] = useState(0);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const selectedMetric = Object.values(EngagementVerticals).map((item) => item.dataKey)[selectedTab];
    const { segmentsApiService } = useMemo(
        () => ({
            segmentsApiService: new SegmentsApiService(),
        }),
        [],
    );
    const [segmentMMXGroupGraphData, segmentMMXGroupGraphDataOps] = useLoading<ISegmentsMMXGraphData>();

    React.useEffect(() => {
        delete apiParams.id;
        segmentMMXGroupGraphDataOps.load(() =>
            segmentsApiService.getCustomSegmentMarketingMixGraphData({
                ...apiParams,
                segmentGroupId: params.id,
                timeGranularity: "Monthly",
                keys: "null",
                webSource: params.webSource,
                includeSubDomains: true,
                lastUpdated: groupData.lastUpdatedTime,
            }),
        );
    }, [params]);

    const isMMXGraphLoading = [useLoading.STATES.INIT, useLoading.STATES.LOADING].includes(
        segmentMMXGroupGraphData.state,
    );

    React.useEffect(() => {
        if (!isMMXGraphLoading) {
            const currentGroup = groups.find((group) => group.id === params.id);
            setMissingFireboltSegment(
                currentGroup?.members.length - Object.keys(segmentMMXGroupGraphData?.data ?? {}).length,
            );
        }
    }, [params, groups, isMMXGraphLoading]);
    const allSegments = useMemo(() => [...organizationSegments, ...segments], [organizationSegments, segments]);
    const graphProps = {
        groups,
        data: segmentMMXGroupGraphData.data,
        params,
        onGraphDDClick: (obj) => console.log("downloading graph " + obj.id),
        onScatterDDClick: (obj) => console.log("downloading scatter " + obj.id),
        tableExcelLink: "",
        selectedRows: selectedRows,
        isLoading: isMMXGraphLoading,
        rowSelectionProp: "id",
        setSelectedDisplayTypeIndex,
        selectedDisplayTypeIndex,
        allSegments,
        selectedMetric,
        selectedTab,
        setSelectedTab,
        groupData,
    };

    const tableProps = {
        isLoading: isMMXGraphLoading,
        data: segmentMMXGroupGraphData.data,
        selectedRows: selectedRows,
        tableSelectionKey: "SegmentMMXGroupTable",
        tableSelectionProperty: "id",
        selectedDisplayTypeIndex,
        allSegments,
        params,
        groups,
        selectedMetric,
    };

    return (
        <GroupMMXContainer>
            <SegmentsGroupMMXGraph {...graphProps} />
            <SegmentsGroupMMXTable {...tableProps} />
        </GroupMMXContainer>
    );
};

function mapStateToProps(state) {
    const {
        segmentsModule: { customSegmentsMeta },
    } = state;
    return {
        selectedRows: getTableSelectedItems("SegmentMMXGroupTable")(state),
        customSegmentsData: customSegmentsMeta?.AccountSegments,
        segments: customSegmentsMeta?.Segments,
        groups: customSegmentsMeta?.SegmentGroups,
    };
}

export const ConnectSegmentsGroupMarketingChannelsContainer = connect(
    mapStateToProps,
    null,
)(SegmentsGroupMarketingChannelsContainer);
